const concat = (a, b) => a.concat(b);
export default concat;
